<bz-table uniqueId="threepl-train-vouchers"
          appBringozIdGenerator="threepl-vouchers-table"
          [items]="items()"
          [isLoading]="loading()"
          [rowHeight]="80"
          [resizable]="false"
          (fetchNext)="fetchNext.emit()">
  <ng-template bzTableHeader>
    <div class="th col-number">{{ 'Voucher Number' | translate }}</div>
    <div class="th col-external-id">{{ 'External ID' | translate }}</div>
    <div class="th col-created-at">{{ 'Created At' | translate }}</div>
    <div class="th col-status">{{ 'Status' | translate }}</div>
    <div class="th col-train-status">{{ 'Train Status' | translate }}</div>
    <div class="th col-loading-date">{{ 'Loading Date' | translate }}</div>
    <div class="th col-origin">{{ 'Origin' | translate }}</div>
    <div class="th col-destination">{{ 'Destination' | translate }}</div>
    <div class="th col-total-cars">{{ 'Total Cars' | translate }}</div>
    <div class="th col-total-weight">{{ 'Total Weight' | translate }}</div>
    <div class="th col-row-actions"></div>
  </ng-template>

  <ng-template bzTableRow let-voucher>
    <app-threepl-train-vouchers-table-row appBringozIdGenerator="threepl-vouchers-table-row"
                                          [voucher]="voucher"
                                          (voucherSelect)="voucherSelect.emit($event)"
                                          (voucherComplete)="voucherComplete.emit($event)"
                                          (voucherCancel)="voucherCancel.emit($event)"
                                          (voucherPrint)="voucherPrint.emit($event)">
    </app-threepl-train-vouchers-table-row>
  </ng-template>

  <bz-empty-state bzTableEmptyState
                  [title]="'No Vouchers Found' | translate"
                  image="assets/images/empty_state/empty_state_priceplans.png">
  </bz-empty-state>
</bz-table>
